import React, { useRef, useEffect } from "react"
import gsap from "gsap"

export interface SlidingTextProps {
  children: React.ReactNode
  speed?: number
}

const SlidingBar = ({ children, speed = 10 }: SlidingTextProps) => {
  const marqueeRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (!marqueeRef?.current) {
      return
    }

    const element = marqueeRef.current
    const tl = gsap.timeline({
      repeat: -1, // endless loop
      defaults: {
        ease: "linear",
      },
    })

    const containerWidth = element.offsetWidth
    tl.fromTo(
      element,
      { x: containerWidth },
      { x: -element.scrollWidth, duration: 15, immediateRender: false }
    )

    return () => {
      tl.kill()
    }
  }, [children])

  return (
    <div style={{ overflow: "hidden", whiteSpace: "nowrap", width: "100%" }}>
      <div ref={marqueeRef} style={{ display: "block" }}>
        {children}
      </div>
    </div>
  )
}

export default SlidingBar
